import { render, staticRenderFns } from "./BuisnessCard.vue?vue&type=template&id=05b61418&scoped=true&"
import script from "./BuisnessCard.vue?vue&type=script&lang=ts&"
export * from "./BuisnessCard.vue?vue&type=script&lang=ts&"
import style0 from "./BuisnessCard.vue?vue&type=style&index=0&id=05b61418&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b61418",
  null
  
)

export default component.exports